module.exports = __webpack_public_path__ + "static/DataFleets-c51ccd1995f0d0a8ac826c53ffd908f7.jpg";